import { render, staticRenderFns } from "./site-device-view.vue?vue&type=template&id=e1275ce2&scoped=true"
import script from "./site-device-view.vue?vue&type=script&lang=js"
export * from "./site-device-view.vue?vue&type=script&lang=js"
import style0 from "./site-device-view.vue?vue&type=style&index=0&id=e1275ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1275ce2",
  null
  
)

export default component.exports